var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-item",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"btn-item__icon",style:({
      background: _vm.background
    })},[_c('i',{class:_vm.icon})]),_c('div',{staticClass:"btn-item__text"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }